// extracted by mini-css-extract-plugin
module.exports =  {"container":"_0bc5e8de02--container--LChJ2","title":"_0bc5e8de02--title--IqcK_","description":"_0bc5e8de02--description--CVyjq"};